import React from 'react';
import { useTranslation } from 'react-i18next';
import './ContactForm.scss';

interface ContactFormProps {
  isAuthenticated: boolean;
  onSubmit: (data: ContactFormData) => void;
  defaultValues?: Partial<ContactFormData>;
}

export interface ContactFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  comment: string;
}

export const ContactForm: React.FC<ContactFormProps> = ({ /*isAuthenticated,*/ onSubmit, defaultValues }) => {
  const { t } = useTranslation('contact');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData(e.target as HTMLFormElement);
    const data = Object.fromEntries(formData.entries()) as unknown as ContactFormData;
    onSubmit(data);
  };

  return (
    <div className="contact-form">
      <h1 className="contact-form__title">{t('title')}</h1>
      <p className="contact-form__subtitle">{t('subtitle')}</p>

      <form onSubmit={handleSubmit} className="contact-form__form">
        <div className="form-row">
          <div className="form-field">
            <label className="form-field__label" htmlFor="firstName">
              {t('form.firstName')}
            </label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              className="form-field__input"
              required
              defaultValue={defaultValues?.firstName}
            />
          </div>

          <div className="form-field">
            <label className="form-field__label" htmlFor="lastName">
              {t('form.lastName')}
            </label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              className="form-field__input"
              required
              defaultValue={defaultValues?.lastName}
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-field">
            <label className="form-field__label" htmlFor="email">
              {t('form.email')}
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="form-field__input"
              required
              defaultValue={defaultValues?.email}
            />
          </div>

          <div className="form-field">
            <label className="form-field__label" htmlFor="phone">
              {t('form.phone')}
            </label>
            <input
              type="tel"
              id="phone"
              name="phone"
              className="form-field__input"
            />
          </div>
        </div>

        <div className="form-row full-width">
          <div className="form-field">
            <label className="form-field__label" htmlFor="comment">
              {t('form.comment')}
            </label>
            <textarea
              id="comment"
              name="comment"
              placeholder={t('form.commentPlaceholder')}
              className="form-field__textarea"
              rows={5}
              required
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="form-button">
            {t('form.submit')}
          </button>
        </div>
      </form>
    </div>
  );
};
